export const HELP_PANEL_VERSION = '1';
export const HELP_PANEL_ID = 'helpPanel';
export const HELP_PANEL_WIDTH = 368;
